/* eslint-disable */
export default {
  onSearching: '로드 중...',
  noContacts: '레코드를 찾을 수 없습니다.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
